<template>
  <span class="bb-balance-link"
        v-if="itemsData.length"
  >
    <span v-for="(item, index) in overpaidInvoices"
          :key="item._id"
          class="bb-balance-link__text"
          @click="openBalanceLink(item)"
    >
      {{item.number}}<span v-if="index !== itemsData.length - 1 && itemsData.length !== 1"> /</span>
    </span>
  </span>
</template>

<script>
import {get} from 'lodash'
export default {
  name: 'BalanceLink',
  props: ['item'],
  computed: {
    itemsData () {
      return get(this.item, 'overpaidInvoices', [])
    }
  },
  methods: {
    openBalanceLink (item) {
      this.$emit('openBalanceLink', item)
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-balance-link {
    position: relative;

    &__text {
      color: $color-accent;
      cursor: pointer;

      &:hover {
        color: $color-accent-hover;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableBalance/BalanceLink.vue